<template>
  <NoteSection
    label="General Appearance"
    required
    :has-error="isGeneralAppearancesError"
    :highlight-required="isSectionIncomplete"
    :form-validated="formValidated"
  >
    <check-boxes
      v-model="general_appearances"
      :items="generalAppearances"
      class="col-sm-12 mt--1"
      columns="3"
      hide-details
      radio-buttons
      required
      return-object
    ></check-boxes>
    <text-field
      v-if="isOtherSelected"
      v-model="general_appearances_other"
      class="col-sm-12"
      label="Enter other general appearance..."
      counter="800"
      maxlength="800"
      required
    ></text-field>
  </NoteSection>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    generalAppearancesOther: {
      type: String,
      default: null,
    },
    formValidated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      general_appearances: [...(this.value || [])],
      general_appearances_other: this.generalAppearancesOther,
    }
  },
  computed: {
    ...mapGetters('encounters', ['generalAppearances']),
    isGeneralAppearancesError() {
      const v = this.general_appearances
      return !v || v.length === 0
    },
    isOtherSelected() {
      return Array.isArray(this.general_appearances) && this.general_appearances.some(x => x.title === 'Other')
    },
    // Evaluates if any required field within General Appearance is incomplete
    isSectionIncomplete() {
      if (this.isGeneralAppearancesError) {
        return true
      }
      if (this.isOtherSelected && (!this.general_appearances_other || !this.general_appearances_other.trim())) {
        return true
      }
      return false
    },
  },
  watch: {
    general_appearances() {
      this.$emit('input', this.general_appearances)
    },
    general_appearances_other() {
      this.$emit('update:general-appearances-other', this.general_appearances_other)
    },
  },
  methods: {
  },
}
</script>
